import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LoginRoutingModule} from './login-routing.module';
import {LoginComponent} from './login.component';
import {InputTextModule} from 'primeng/inputtext';
import {ButtonModule} from 'primeng/button';
import {AppConfigModule} from 'src/app/layout/config/config.module';
import {RippleModule} from 'primeng/ripple';
import {ImageModule} from 'primeng/image';
import {FormsModule} from '@angular/forms';
import {ToastModule} from 'primeng/toast';
import {DividerModule} from 'primeng/divider';
import {LoginFooterComponent} from "./components/login-footer/login-footer.component";
import {SidebarModule} from "primeng/sidebar";
import {LoginHeaderComponent} from "./components/login-header/login-header.component";
import {PasswordModule} from "primeng/password";
import {IconFieldModule} from "primeng/iconfield";
import {InputIconModule} from "primeng/inputicon";
import {PrimeNgModule} from "../../shared/prime-ng/prime-ng.module";

@NgModule({
    imports: [
        CommonModule,
        LoginRoutingModule,
        ButtonModule,
        InputTextModule,
        RippleModule,
        AppConfigModule,
        ImageModule,
        FormsModule,
        ToastModule,
        DividerModule,
        LoginFooterComponent,
        SidebarModule,
        LoginHeaderComponent,
        PasswordModule,
        IconFieldModule,
        InputIconModule,
        PrimeNgModule
    ],
    declarations: [LoginComponent]
})
export class LoginModule {
}
